module.exports = __webpack_public_path__ + "images/dynamic-c605baba4ba9b42eddb17f2eda12ee3b.jpg";